import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd';
import Axios from 'axios';
import { API_URL } from '../../../config';

const PublicGuiaDownload: React.FC = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const downloadPdf = async () => {
      try {
        const response = await Axios.get(`${API_URL}/public/guias/${uuid}`, {
          responseType: 'blob'
        });

        // Crear un blob URL para el PDF
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        // Crear un enlace temporal para descargar el archivo
        const link = document.createElement('a');
        link.href = url;
        link.download = `guia-${uuid}.pdf`;

        // Agregar el enlace al DOM y hacer clic para descargar
        document.body.appendChild(link);
        link.click();

        // Limpiar
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        // Cerrar la pestaña después de un breve delay para asegurar que la descarga inicie
        setTimeout(() => {
          window.close();
        }, 1000);
      } catch (error) {
        console.error('Error al descargar el PDF:', error);
        setLoading(false);
        // Mostrar mensaje de error y cerrar la pestaña después
        alert('Error al descargar el PDF. El enlace podría ser inválido o expirado.');
        setTimeout(() => {
          window.close();
        }, 2000);
      }
    };

    if (uuid) {
      downloadPdf();
    }
  }, [uuid]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px'
      }}
    >
      <Spin size="large" />
      <p style={{ marginTop: '20px', fontSize: '16px', color: '#666' }}>
        {loading ? 'Descargando PDF...' : 'Error al descargar el PDF'}
      </p>
    </div>
  );
};

export default PublicGuiaDownload;
